import React from 'react';

function AdminModal({ title, children, onClose, wide }) {
  return (
    <div className="admin-modal-backdrop" onClick={onClose} role="presentation">
      <div
        className={`admin-modal${wide ? ' admin-modal-wide' : ''}`}
        onClick={event => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="admin-modal-header">
          <h3>{title}</h3>
          <button type="button" className="admin-btn admin-btn-ghost" onClick={onClose}>
            Close
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export default AdminModal;
